export const cookie = {
  token: '__dacum_token__',
  profile: '__dacum_profile__',
  expiresAt: '__dacum_expires_at__',
  tokenExpiresAt: '__dacum_token_expires_at__',
  msalAccountId: '__dacum_msal_account_id__'
};

export type StatusType = keyof typeof statusData;

export type StatusPlan =
  | 'Published'
  | 'Cancelled'
  | 'Deleted'
  | 'Active'
  | 'Pending'
  | 'Completed'
  | 'Cancelled'
  | 'Draft'
  | 'Need Approval'
  | 'Upcoming'
  | 'Need Action'
  | 'No Schedule'
  | 'Confirmed';
export type StatusLabel = Lowercase<StatusType>;

export const statusData = {
  active: {
    label: 'Active',
    color: '#4CAF50'
  },
  pending: {
    label: 'Pending',
    color: '#FFA000'
  },
  completed: {
    label: 'Completed',
    color: '#2196F3'
  },
  cancelled: {
    label: 'Cancelled',
    color: '#F3352E'
  },
  inactive: {
    label: 'Inactive',
    color: '#F3352E'
  },
  deleted: {
    label: 'Deleted',
    color: '#F3352E'
  },
  draft: {
    label: 'Draft',
    color: '#9AA1B1'
  },
  published: {
    label: 'Published',
    color: '#1BA42F'
  },
  'need approval': {
    label: 'Need Approval',
    color: '#2A62EA'
  },
  upcoming: {
    label: 'Upcoming',
    color: '#2A62EA'
  },
  'need action': {
    label: 'Need Action',
    color: '#FE9F12'
  },
  'in review': {
    label: 'In Review',
    color: '#FE9F12'
  },
  'no schedule': {
    label: 'No Schedule',
    color: '#9AA1B1'
  },
  approved: {
    label: 'Approved',
    color: '#4CAF50'
  },
  rejected: {
    label: 'Rejected',
    color: '#F3352E'
  }
};

export const optionStatus = [
  {
    label: 'Active',
    color: '#4CAF50'
  },
  {
    label: 'Pending',
    color: '#FFA000'
  },
  {
    label: 'Completed',
    color: '#2196F3'
  },
  {
    label: 'Cancelled',
    color: '#F3352E'
  },
  {
    label: 'Inactive',
    color: '#F3352E'
  },
  {
    label: 'Draft',
    color: '#9AA1B1'
  },
  {
    label: 'Published',
    color: '#1BA42F'
  }
];

export const statusCourse = [
  {
    label: 'Active',
    value: 'Active'
  },
  {
    label: 'No Schedule',
    value: 'No Schedule'
  },
  {
    label: 'Upcoming',
    value: 'Upcoming'
  },
  {
    label: 'Completed',
    value: 'Completed'
  }
];

export const getStatusColor = (status: StatusLabel): string => {
  const statusKey = status.toLowerCase() as StatusType;
  return statusData[statusKey]?.color;
};

export const getStatusLabel = (status: StatusLabel): string => {
  const statusKey = status.toLowerCase() as StatusType;
  return statusData[statusKey]?.label;
};

export const CORE_COMPETENCIES = [
  {
    label: 'Core Competency',
    value: 'core'
  },
  {
    label: 'Competency FM',
    value: 'faculty manager'
  },
  {
    label: 'Competency Leadership',
    value: 'leadership'
  }
];
